function enhanceForminatorSubmitButtons(root) {
  root.querySelectorAll(".forminator-button-submit:not(.cta-btn-desktop)").forEach(btn => {
    const label = btn.textContent.trim();
    btn.textContent = "";

    const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    svg.setAttribute("class", "arrow-svg");
    svg.setAttribute("width", "24");
    svg.setAttribute("height", "20");
    svg.setAttribute("viewBox", "0 0 24 20");
    svg.setAttribute("fill", "none");
    svg.innerHTML = '<path d="M14.3076 0.549805L23.1074 9.5498L23.21 9.6543L23.1074 9.75879L14.3076 18.7588L14.2002 18.8691L14.0928 18.7588L12.5527 17.1846L12.4502 17.0791L12.5527 16.9746L18.4639 10.9297H0.849609V8.37891H18.4639L12.5527 2.33398L12.4502 2.22949L12.5527 2.12402L14.0928 0.549805L14.2002 0.439453L14.3076 0.549805Z" fill="black" stroke="black" stroke-width="0.3"/>';

    const span = document.createElement("span");
    span.className = "btn-text";
    span.textContent = label;

    btn.append(svg, span);
    btn.classList.add("cta-btn-desktop");
  });
}

// root scopes queries so re-running on swup content changes only binds
// buttons inside the swapped container, not ones already bound elsewhere
// (e.g. the footer's "Get Started" button, which persists across page transitions).
export function initializeButtonAnimations(root = document) {
  enhanceForminatorSubmitButtons(root);

  root.querySelectorAll(".cta-btn-desktop").forEach(btn => {
    const svg = btn.querySelector("svg");
    const span = btn.querySelector("span");

    let attempts = 0;
    const maxAttempts = 50; // ~1 second max

    const calculate = () => {
      attempts++;

      // Wait until button is visible and measurable
      if (
        btn.offsetWidth === 0 ||
        btn.offsetHeight === 0 ||
        !svg ||
        !span
      ) {
        if (attempts < maxAttempts) {
          requestAnimationFrame(calculate);
        }
        return;
      }

      const svgWidth = svg.getBoundingClientRect().width;
      const spanWidth = span.getBoundingClientRect().width;

      // Still 0? Retry.
      if ((svgWidth === 0 || spanWidth === 0) && attempts < maxAttempts) {
        requestAnimationFrame(calculate);
        return;
      }

      // If STILL 0, we stop
      if (svgWidth === 0 || spanWidth === 0) {
        console.warn("Button dimensions not ready after retries:", btn);
        return;
      }

      // Compute gap
      const computedStyle = window.getComputedStyle(btn);
      const gapValue = computedStyle.gap || computedStyle.columnGap || "12px";
      const gap = parseFloat(gapValue) || 12;

      // Set CSS variables
      btn.style.setProperty("--svg-move-distance", `${spanWidth + gap}px`);
      btn.style.setProperty("--span-move-distance", `-${svgWidth + gap}px`);
    };

    // Ensure fonts are ready
    document.fonts.ready.then(() => {
      requestAnimationFrame(calculate);
    });

    // Recalculate on resize
    window.addEventListener("resize", calculate);
  });
}
